import moment from 'moment';
import { selectUser } from '../../state/user/userSlice';
// import { selectSessions } from '../../state/chat/chatSlice';

import store from '../../state/store';
import findSessionFromContactArr from './findSessionFromContactArr';
import getPartipcantNames from '../contact/getParticipantNames';
import generateChatSessionId from './generateChatSessionId';

const generateChatObjectFromChips = (chipData) => {
  const debug = false;
  const chatObject = {};
  const user = selectUser(store.getState());
  if (debug) console.debug('in generateChatObjectFromChips this is chipData: ', chipData);

  // make contactArr
  const contactArr = [];
  chipData.forEach((chip) => {
    if (debug) console.debug('this is chip: ', chip);

    if (chip.contact) {
      contactArr.push(chip.contact);
    } else {
      // TODO contact was not found, search for one, if none is found, make a temp one
    }
  });

  // look for session in current data of sessions
  // const session;
  const sessionFound = findSessionFromContactArr(contactArr);

  // put first contact
  const [firstContact] = contactArr;
  chatObject.contact = firstContact;

  // put contactArr
  chatObject.contactArr = contactArr;

  // put domain
  chatObject.domain = user.domain;

  // put id, which is the session id
  chatObject.id = sessionFound?.id || generateChatSessionId(contactArr);

  // put lastMessage
  chatObject.lastMessage = sessionFound?.lastMessage || '';

  chatObject.lastSender = sessionFound?.lastSender || '';

  chatObject.lastStatus = sessionFound?.lastStatus || 'read';

  chatObject.lastTimestamp = sessionFound?.lastTimestamp || moment.utc().format('YYYY-MM-DD HH:mm:ss');

  chatObject.muted = sessionFound?.muted || 'no';

  chatObject.numPart = sessionFound?.numPart || contactArr.length;

  chatObject.partNames = sessionFound?.partNames || getPartipcantNames(contactArr);

  chatObject.remote = sessionFound?.remote || '';

  chatObject.session_name = sessionFound?.session_name || '';

  chatObject.smsani = sessionFound?.smsani || '';

  chatObject.startTimestamp = sessionFound?.startTimestamp || null;

  if (debug) console.debug('this is chatObject: ', chatObject);
  return chatObject;
};

export default generateChatObjectFromChips;
